import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const TheWeek: Site = {
  id: 'theweek',
  logo: 'svg/theweek.svg',
  label: 'The Week.com',
  analyticsName: 'theweek',
  hostname: 'theweek.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
